module.exports = __webpack_public_path__ + "img/unchecked.2ea48f01.png";